import { default as api } from 'config/authApiConf.js';

export const listLogoService = async (page = 1) => {
	try {
		let result = await api.get(`/cms/list-logo?page=${page}`);
		return result;
	} catch (error) {
		return error;
	}
};
